export default __webpack_public_path__ + "static/media/G6.5f0ff545.mp3";